import { css, fadeColor, getColor, lightenColor, styled, keyframes } from "imaginarity-react-ui";


const SlideInTop = keyframes`
 0% {
    -webkit-transform: translateY(-40px);
            transform: translateY(-40px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    opacity: 1;
  }
`;

const SlideOutTop = keyframes`
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateY(-40px);
            transform: translateY(-40px);
    opacity: 0;
  }
`;

const NumberEnterBottom = keyframes`
  0%   { transform: translateY(100%); opacity: 0; }
  100% { transform: translateY(0);    opacity: 1; }
`;

const NumberExitTop = keyframes`
  0%   { transform: translateY(0);     opacity: 1; }
  100% { transform: translateY(-100%); opacity: 0; }
`;




export class InfoBoxSC {
  public static InfoBoxContainer = styled.div<{ color: string, hide: boolean, darkMode: boolean, icon: boolean, noBold: boolean, noUppercase: boolean, animated: boolean, noBorder: boolean, noLetterSpacing: boolean, closing: boolean }>`
    display: ${p => p.hide ? "none" : "grid"};
    grid-template-columns: ${p => p.icon ? "40px 1fr" : "1fr"};
    grid-template-rows: 1fr;
    width: 100%;
    min-height: 40px;
    line-height: 40px;
    font-size: 0.9rem;
    text-transform: ${p => p.noUppercase ? undefined : "uppercase"};
    letter-spacing: ${p => p.noLetterSpacing ? "unset" : "1.1px"};
    font-weight: ${p => p.noBold ? "normal" : "bolder"};
    color: ${p => p.darkMode ? getColor(p, p.color) : lightenColor(p, p.color, 70)};
    background: ${p => fadeColor(p, p.color, 5)};
    border: ${p => p.noBorder ? "none" : `1px solid ${getColor(p, p.color)}`};
    margin-bottom: 10px;
    button>div{margin: 0;}
    ${p => p.animated ? css`animation: ${p.closing ? SlideOutTop : SlideInTop} 0.2s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;` : ""}

    button>div{
      svg{
        stroke: ${p => getColor(p, p.color)};
      }
    &:hover{
      svg{
        stroke: ${p => getColor(p, "color")};
      }
    }
    }
    .icon{
        float: left;
        height: 40px;
        width: 40px;
        text-align: center;
        margin-right: 10px;
        background: ${p => fadeColor(p, p.color, 15)};
        svg{
            stroke: ${p => p.darkMode ? getColor(p, p.color) : lightenColor(p, p.color, 70)};
          }
    }
`;
  public static InfoBoxContainerBtn = styled.div<{ color: string }>`
    float: right;
    width: fit-content;
    button{
      color: #fff;
    }
    svg{
      stroke: #fff !important;
    }
    `;

  public static CountdownContainer = styled.div<{ color: string }>`
    position: relative;
    overflow: hidden;
    width: 1.4em;
    height: 1.2em;
    line-height: 1.2em;
    float: right;
    margin: calc((40px - 1.2em) / 2) 10px 0 0;
    color: ${p => getColor(p, p.color)};
  `;

  public static CountdownDigit = styled.div<{ state: 'entering' | 'exiting' | 'idle' }>`
    position: absolute;
    width: 100%;
    text-align: center;
    ${p => p.state === 'entering' ? css`animation: ${NumberEnterBottom} 0.5s ease both;` :
      p.state === 'exiting' ? css`animation: ${NumberExitTop}    0.5s ease both;` : ''}
  `;
}